import React, { useState, useEffect } from "react"
import { Row, Col, Form, Label, Input, ButtonGroup } from "reactstrap"
import { useTranslation } from "react-i18next"
import { withRouter } from "react-router-dom"
import { is_empty } from "../../config/validate"
import LabelChargeData from "../../components/Common/labelChargeData"
import showToast from "../../components/Common/viewNotification"
//redux

import { useSelector, useDispatch } from "react-redux"
import { saveBankNew, editBank } from "../../store/banks/actions"
const BankForm = props => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  // eslint-disable-next-line react/prop-types
  const { onClosing, isEdit, currentBank, onLoad } = props
  const [id, setId] = useState(null)
  const [name, setName] = useState({ value: "", error: "" })
  const [code, setCode] = useState({ value: "", error: "" })
  const [status, setStatus] = useState(true)
  const [auth] = useState(JSON.parse(sessionStorage.getItem("user")))
  let [errors, setErrors] = useState([])
  //#region storage
  const { loading, response } = useSelector(state => ({
    loading: state.Banks.loadingSave,
    response: state.Banks.response 
  }))
  //#endregion
  

  useEffect(() => {
    if (response !== null) {
      clearForm()
      onLoad()
    }
  }, [response])

  useEffect(() => {
    if (currentBank) {
      setData()
    }
  }, [currentBank])
  
  const validate = () => {
    errors = []
    if (is_empty(name.value)) {
      name.error = t("error:required")
      errors.push(name.error)
    }
    if (is_empty(code.value)) {
      code.error = t("error:required")
      errors.push(code.error)
    }

    setErrors(errors)
  }
  const handleSubmit = async () => {
    validate()
    if (errors.length === 0) {
      let values = {
        id: id,
        name: name.value,
        code: code.value,
        createdBy: auth.id.user.username,
        society: "BO81",
        status: 1,
      }
      if (values.id) {
        await dispatch(editBank(values))
      } else {
        await dispatch(saveBankNew(values))
      }
    }
  }

  const clearForm = async () => {
    if (!isEdit) {
      setId(null)
      setName({ value: "", error: "" })
      setCode({ value: "", error: "" })
    } else {
      currentBank.name = name.value
    }
  }
  const setData = () => {
    setId(currentBank.id)
    setName({ value: currentBank.name, error: "" })
    setCode({ value: currentBank.code, error: "" })
    setStatus(currentBank.status === 1 ? true : false)
  }
  return (
    <React.Fragment>
      <Form>
        <Row>
          <Col xs={12}>
            <div className="mb-3">
              <Label htmlFor="name">{t("banks:titleDtName")}</Label>
              <Input
                autoComplete="new-text"
                type="text"
                className="form-control"
                value={name.value || ""}
                onChange={e => {
                  setName({ value: e.target.value, error: "" })
                }}
              />
              <span className="small text-danger">{name.error}</span>
            </div>
            <div className="mb-3">
              <Label htmlFor="name">{t("banks:titleDtCode")}</Label>
              <Input
                autoComplete="new-text"
                type="text"
                className="form-control"
                value={code.value || ""}
                onChange={e => {
                  setCode({ value: e.target.value, error: "" })
                }}
              />
              <span className="small text-danger">{code.error}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <LabelChargeData
              label={""}
              showloading={loading}
              title={t("global:registerloading")}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="modal-footer">
              <ButtonGroup>
                <button
                  type="button"
                  className="btn btn-info save-user"
                  disabled={loading}
                  onClick={handleSubmit}
                >
                  <i className=" fas fa-save me-1 " />
                  {t("global:save")}
                </button>
                <button
                  type="button"
                  className="btn btn-danger "
                  disabled={loading}
                  onClick={() => {
                    onClosing(false)
                  }}
                >
                  {" "}
                  {t("global:close")}
                </button>
              </ButtonGroup>
            </div>
          </Col>
        </Row>
      </Form>
    </React.Fragment>
  )
}
export default withRouter(BankForm)
